import laundriesService from "api/laundriesService";
import { useMutation } from "react-query";

import { IChangeLaundryCommissionBody } from "types/laundry";

const useChangeLaundryCommissionMutation = () => {
  return useMutation(async (data: IChangeLaundryCommissionBody) => {
    try {
      const res = await laundriesService.changeLaundryCommission(data)

      return res.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  }) 
}

export default useChangeLaundryCommissionMutation